module.exports = __webpack_public_path__ + "img/25761bad-f73c-436d-bc07-670cf37d7270.045.a4ab1d44.png";